/**
 * Module Api Schema - Modal Registry
 */
import React from 'react';

const ProjectFormModal = React.lazy(() => import('../ApiProject/components/FormModal'));
const EnvironmentFormModal = React.lazy(() => import('../ApiEnvironment/components/FormModal'));
const SavedRequestFormModal = React.lazy(() => import('../ApiSavedRequest/components/FormModal'));

const apiSchemaModalRegistry = {
    api_projectId: ProjectFormModal,
    api_environmentId: EnvironmentFormModal,
    api_savedRequestId: SavedRequestFormModal,
};

export default apiSchemaModalRegistry;
